const ACTIONS = {
    GET_DATA_SUCCESS: 'GET_DATA_SUCCESS',
    GET_DATA_ERROR: 'GET_DATA_ERROR',
    GET_HEADER_PLAYER_PERFORMANCE_SUCCESS: 'GET_HEADER_PLAYER_PERFORMANCE_SUCCESS',
    GET_HEADER_PLAYER_PERFORMANCE_ERROR: 'GET_HEADER_PLAYER_PERFORMANCE_ERROR',
    GET_PLAYER_BATTER_BASIC_SUCCESS: 'GET_PLAYER_BATTER_BASIC_SUCCESS',
    GET_PLAYER_BATTER_BASIC_ERROR: 'GET_PLAYER_BATTER_BASIC_SUCCESS',
    GET_PLAYER_CONDITION_BATTER_SUCCESS: 'GET_PLAYER_CONDITION_BATTER_SUCCESS',
    GET_PLAYER_CONDITION_BATTER_ERROR: 'GET_PLAYER_CONDITION_BATTER_ERROR'
};

const headerDeregis = ['公示日', '選手動向名']
const titleDeregis = {
    dot: false,
    text: '登録抹消情報',
};
const dataDeregis = [
    {
        item: [
            { text: '2019/4/12' },
            { text: '次年度契約保留選手' },
        ]
    },
    {
        item: [
            { text: '2019/4/12' },
            { text: '次年度契約保留選手' },
        ]
    },
    {
        item: [
            { text: '2019/4/12' },
            { text: '次年度契約保留選手' },
        ]
    },
];
const headerPitcher1 = ['球種名', '投球割合', '被打率', '空振り率'];
const headerPitcher2 = ['内訳', '打球数', '割合'];
const headerAchievement = ['記録名', '残り記録']
const titleAchievement = {
    dot: false,
    text: '達成間近記録',
}
const titleHitting = {
    dot: false,
    text: '打撃成績',
}
const headerHitting = ['年度', 'チーム', '試合', '打席', '打数', '得点', '安打', '二塁打', '三塁打', '本塁打', '塁打',
    '打点', '三振', '四球', '敬遠', '死球', '犠打', '犠飛', '盗塁', '盗塁刺', '併殺打', '失策', '打率', '長打率', '出塁率', 'OPS',]
const dataHitting = [
    {
        item: [
            { text: '2007' },
            { img: '/img/team/Giants.png' },
            { text: 0 },
            { text: 0 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
        ]
    },
    {
        item: [
            { text: '2007' },
            { img: '/img/team/Giants.png' },
            { text: 0 },
            { text: 0 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
        ]
    },
    {
        item: [
            { text: '2007' },
            { img: '/img/team/Giants.png' },
            { text: 0 },
            { text: 0 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
        ]
    },
    {
        item: [
            { text: '2007' },
            { img: '/img/team/Giants.png' },
            { text: 0 },
            { text: 0 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
        ]
    },
    {
        item: [
            { text: '2007' },
            { img: '/img/team/Giants.png' },
            { text: 0 },
            { text: 0 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
        ]
    },
    {
        item: [
            { text: '2007' },
            { img: '/img/team/Giants.png' },
            { text: 0 },
            { text: 0 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
        ]
    },
    {
        item: [
            { text: '2007' },
            { img: '/img/team/Giants.png' },
            { text: 0 },
            { text: 0 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
        ]
    },
    {
        item: [
            { text: '2007' },
            { img: '/img/team/Giants.png' },
            { text: 0 },
            { text: 0 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
        ]
    },
    {
        item: [
            { text: '2007' },
            { img: '/img/team/Giants.png' },
            { text: 0 },
            { text: 0 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
        ]
    },
    {
        item: [
            { text: '2007' },
            { img: '/img/team/Giants.png' },
            { text: 0 },
            { text: 0 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
        ]
    },
    {
        item: [
            { text: '通算' },
            { text: 0 },
            { text: 0 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
            { text: '3.26' },
        ]
    },
]

const titlePitching = {
    dot: false,
    text: '投手成績',
}
const headerPitching = ['年度', 'チーム', '防御率', '登板', '先発', '完投', '完封', '無四球', '交代完了', '勝数', '負数', 'セーブ', 'ホールド',
    'HP', '勝率', '投球回', '打者', '被安打', '被本塁打', '与四球', '与死球', '奪三振', '暴投', 'ボーク', '失点', '自責点', '被打率']
const dataPitching = [
    {
        item: [
            { text: '2007' },
            { img: '/img/team/Giants.png' },
            { text: '326' },
            { text: '26' },
            { text: '26' },
            { text: '0' },
            { text: '0' },
            { text: '0' },
            { text: '0' },
            { text: '15' },
            { text: '4' },
            { text: '0' },
            { text: '0' },
            { text: '0' },
            { text: '.798' },
            { text: '170 1/3' },
            { text: '705' },
            { text: '19.9' },
            { text: '12.5' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
        ]
    },
    {
        item: [
            { text: '2007' },
            { img: '/img/team/Giants.png' },
            { text: '326' },
            { text: '26' },
            { text: '26' },
            { text: '0' },
            { text: '0' },
            { text: '0' },
            { text: '0' },
            { text: '15' },
            { text: '4' },
            { text: '0' },
            { text: '0' },
            { text: '0' },
            { text: '.798' },
            { text: '170 1/3' },
            { text: '705' },
            { text: '19.9' },
            { text: '12.5' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
        ]
    },
    {
        item: [
            { text: '2007' },
            { img: '/img/team/Giants.png' },
            { text: '326' },
            { text: '26' },
            { text: '26' },
            { text: '0' },
            { text: '0' },
            { text: '0' },
            { text: '0' },
            { text: '15' },
            { text: '4' },
            { text: '0' },
            { text: '0' },
            { text: '0' },
            { text: '.798' },
            { text: '170 1/3' },
            { text: '705' },
            { text: '19.9' },
            { text: '12.5' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
        ]
    },
    {
        item: [
            { text: '2007' },
            { img: '/img/team/Giants.png' },
            { text: '326' },
            { text: '26' },
            { text: '26' },
            { text: '0' },
            { text: '0' },
            { text: '0' },
            { text: '0' },
            { text: '15' },
            { text: '4' },
            { text: '0' },
            { text: '0' },
            { text: '0' },
            { text: '.798' },
            { text: '170 1/3' },
            { text: '705' },
            { text: '19.9' },
            { text: '12.5' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
        ]
    },
    {
        item: [
            { text: '2007' },
            { img: '/img/team/Giants.png' },
            { text: '326' },
            { text: '26' },
            { text: '26' },
            { text: '0' },
            { text: '0' },
            { text: '0' },
            { text: '0' },
            { text: '15' },
            { text: '4' },
            { text: '0' },
            { text: '0' },
            { text: '0' },
            { text: '.798' },
            { text: '170 1/3' },
            { text: '705' },
            { text: '19.9' },
            { text: '12.5' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
        ]
    },
    {
        item: [
            { text: '2007' },
            { img: '/img/team/Giants.png' },
            { text: '326' },
            { text: '26' },
            { text: '26' },
            { text: '0' },
            { text: '0' },
            { text: '0' },
            { text: '0' },
            { text: '15' },
            { text: '4' },
            { text: '0' },
            { text: '0' },
            { text: '0' },
            { text: '.798' },
            { text: '170 1/3' },
            { text: '705' },
            { text: '19.9' },
            { text: '12.5' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
        ]
    },
    {
        item: [
            { text: '2007' },
            { img: '/img/team/Giants.png' },
            { text: '326' },
            { text: '26' },
            { text: '26' },
            { text: '0' },
            { text: '0' },
            { text: '0' },
            { text: '0' },
            { text: '15' },
            { text: '4' },
            { text: '0' },
            { text: '0' },
            { text: '0' },
            { text: '.798' },
            { text: '170 1/3' },
            { text: '705' },
            { text: '19.9' },
            { text: '12.5' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
        ]
    },
    {
        item: [
            { text: '2007' },
            { img: '/img/team/Giants.png' },
            { text: '326' },
            { text: '26' },
            { text: '26' },
            { text: '0' },
            { text: '0' },
            { text: '0' },
            { text: '0' },
            { text: '15' },
            { text: '4' },
            { text: '0' },
            { text: '0' },
            { text: '0' },
            { text: '.798' },
            { text: '170 1/3' },
            { text: '705' },
            { text: '19.9' },
            { text: '12.5' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
        ]
    },
    {
        item: [
            { text: '2007' },
            { img: '/img/team/Giants.png' },
            { text: '326' },
            { text: '26' },
            { text: '26' },
            { text: '0' },
            { text: '0' },
            { text: '0' },
            { text: '0' },
            { text: '15' },
            { text: '4' },
            { text: '0' },
            { text: '0' },
            { text: '0' },
            { text: '.798' },
            { text: '170 1/3' },
            { text: '705' },
            { text: '19.9' },
            { text: '12.5' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
        ]
    },
    {
        item: [
            { text: '通算' },
            { text: '326' },
            { text: '26' },
            { text: '26' },
            { text: '0' },
            { text: '0' },
            { text: '0' },
            { text: '0' },
            { text: '15' },
            { text: '4' },
            { text: '0' },
            { text: '0' },
            { text: '0' },
            { text: '.798' },
            { text: '170 1/3' },
            { text: '705' },
            { text: '19.9' },
            { text: '12.5' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
            { text: '326' },
        ]
    },
];

const headerBatterTableCommon = ["打率", "打数", "安打", "本塁打", "打点", "三振", "四球", "死球", "犠打", "犠飛"]

const titleBatterTable1 = {
    dot: false,
    text: '対セ・リーグ チーム別成績',
}
const headerBatterTable1 = ["対戦", "打率", "試合", "打数", "安打", "本塁打", "得点", "打点", "三振", "四球", "死球", "犠打",
    "犠飛", "盗塁"]
const dataBatterTable1 = [
    {
        item: [
            { img: '/img/team/Swallows.png' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { img: '/img/team/Carp.png' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { img: '/img/team/DeNA.png' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { img: '/img/team/Dragons.png' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { img: '/img/team/Tigers.png' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
]

const titleBatterTable2 = {
    dot: false,
    text: '対パ・リーグ チーム別成績',
}
const headerBatterTable2 = ["対戦", "打率", "試合", "打数", "安打", "本塁打", "得点", "打点", "三振", "四球", "死球", "犠打",
    "犠飛", "盗塁"]
const dataBatterTable2 = [
    {
        item: [
            { img: '/img/team/Swallows.png' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { img: '/img/team/Carp.png' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { img: '/img/team/DeNA.png' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { img: '/img/team/Dragons.png' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { img: '/img/team/Tigers.png' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { img: '/img/team/Tigers.png' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
]

const titleBatterTable3 = {
    dot: false,
    text: '月別成績',
}
const headerBatterTable3 = ["月", "打率", "試合", "打数", "安打", "本塁打", "得点", "打点", "三振", "四球", "死球", "犠打",
    "犠飛", "盗塁"]
const dataBatterTable3 = [
    {
        item: [
            { text: '3月' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '4月' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '5月' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '6月' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '7月' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
]

const titleBatterTable4 = {
    dot: false,
    text: '左右投手別成績',
}
const headerBatterTable4 = ["投手", ...headerBatterTableCommon]
const dataBatterTable4 = [
    {
        item: [
            { text: '右投' },
            { text: '右打席' },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '右投' },
            { text: '右打席' },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
]

const titleBatterTable5 = {
    dot: false,
    text: 'カウント別成績',
}
const headerBatterTable5 = ["カウント", ...headerBatterTableCommon]
const dataBatterTable5 = [
    {
        item: [
            { text: '0-0' },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '0-1' },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '0-2' },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '1-0' },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '1-1' },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '1-2' },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '2-0' },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '2-1' },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '2-2' },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '3-0' },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '3-1' },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '3-2' },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
]

const titleBatterTable6 = {
    dot: false,
    text: '塁状況別成績',
}
const headerBatterTable6 = ["ランナー", ...headerBatterTableCommon]
const dataBatterTable6 = [
    {
        item: [
            { text: '無し' },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '一塁' },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '一二塁' },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '一三塁' },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '二塁' },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '二三塁' },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '三塁' },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '満塁' },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '走者あり' },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '得点圏' },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
]

const titleBatterTable7 = {
    dot: false,
    text: '球場別成績',
}
const headerBatterTable7 = ["球場", "打率", "試合", "打数", "安打", "本塁打", "打点", "三振", "四球", "死球", "犠打", "犠飛", "盗塁"]
const dataBatterTable7 = [
    {
        item: [
            { text: '東京ドーム' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '神宮' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '横浜' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: 'ナゴヤドーム' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '甲子園' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: 'メットライフ' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '京セラD大阪' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '鹿児島' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '熊本' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '札幌ドーム' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '楽天生命パーク' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: 'マツダスタジアム' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '三次' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
]

const titleBatterTable8 = {
    dot: false,
    text: '球種別成績',
}
const headerBatterTable8 = ["球種", ...headerBatterTableCommon]

const titleBatterTable9 = {
    dot: false,
    text: 'コース別成績',
}
const headerBatterTable9 = ["コース", ...headerBatterTableCommon]

const titleBatterTable10 = {
    dot: false,
    text: '高低別成績',
}
const headerBatterTable10 = ["高低", ...headerBatterTableCommon]

const titleBatterTable11 = {
    dot: false,
    text: 'イニング別成績',
}
const headerBatterTable11 = ["イニング", ...headerBatterTableCommon]

export default (state = {
    headerDeregis, dataDeregis, titleDeregis, titleAchievement,
    headerAchievement, titleHitting, headerHitting,
    dataHitting, titlePitching, headerPitching, dataPitching,
    titleBatterTable1, headerBatterTable1, dataBatterTable1, titleBatterTable2,
    dataBatterTable2, headerBatterTable2,
    titleBatterTable3, headerBatterTable3, dataBatterTable3,
    titleBatterTable4, headerBatterTable4, dataBatterTable4,
    titleBatterTable5, headerBatterTable5, dataBatterTable5, titleBatterTable6,
    headerBatterTable6, dataBatterTable6,
    titleBatterTable7, headerBatterTable7, dataBatterTable7,
    titleBatterTable8, headerBatterTable8,
    titleBatterTable9, headerBatterTable9,
    titleBatterTable10, headerBatterTable10,
    titleBatterTable11, headerBatterTable11,
    headerPitcher1, headerPitcher2
}, action) => {
    switch (action.type) {
        case ACTIONS.GET_DATA_SUCCESS:

            return {
                ...state,
                status: action.type,
                response: action.data.data,
            };
        case ACTIONS.GET_HEADER_PLAYER_PERFORMANCE_SUCCESS:
        case ACTIONS.GET_PLAYER_BATTER_BASIC_SUCCESS:
        case ACTIONS.GET_PLAYER_CONDITION_BATTER_SUCCESS:

            return {
                ...state,
                status: action.type,
                response: action.data,
            }
        case ACTIONS.GET_DATA_ERROR:
        case ACTIONS.GET_HEADER_PLAYER_PERFORMANCE_ERROR:
        case ACTIONS.GET_PLAYER_BATTER_BASIC_ERROR:
        case ACTIONS.GET_PLAYER_CONDITION_BATTER_ERROR:
            return {
                    ...state,
                    status: action.type,
                    response: action.err,
                }
        default:
            return state;
    }
};